import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  boxLogoConexa: theme => css`
    width: 100%;
    padding: ${theme.spacing.sm} ${theme.spacing.sm} 20px;
    border-bottom: 1px solid ${theme.colors.neutral[100]};
    background-color: ${theme.colors.background.white};
    img {
      height: 40px;
      max-width: 100%;
      object-fit: contain;
    }
  `,
})

export { useStyles }
